import {Headers} from '@angular/http';
import {NgxPermissionsService} from 'ngx-permissions';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {HttpHeaders} from '@angular/common/http';

@Injectable()
 export class SessionService {
  private authorize = 'https://oauth.intelcia.com/uaa/oauth/authorize';
  private client_id = 'intranet-liferay';
  private response_type = 'code';

  constructor(private permissionsService: NgxPermissionsService, private router: Router) {
  }

  public authredirectTo(url: string) {
    const uri = this.authorize +
              '?response_type=' + this.response_type +
              '&client_id=' + this.client_id +
              '&redirect_uri=' + url;
    window.location.href = uri;
  }

  public setPermission(array) {
    this.permissionsService.loadPermissions(array);
  }

  public CheckResponseData(data: object) {
    return (Object.keys(data).length > 0 );
  }

  public getHeaders() {
    const access_token = localStorage.getItem('myAppAccess');
    const mid = access_token.length / 2;
    const token1 = access_token.slice(0, mid);
    const token2 = access_token.slice(mid);
    const headers = new Headers({
      'Content-Type' : 'application/json; charset=utf-8',
      'Accept'       : 'application/json',
      'Intelcia1'     : token1,
      'Intelcia2'     : token2
    });
    return headers;
  }

  public getHttpHeaders() {
    const access_token = localStorage.getItem('myAppAccess');
    const mid = access_token.length / 2;
    const token1 = access_token.slice(0, mid);
    const token2 = access_token.slice(mid);
    const headers = new HttpHeaders({
      'Content-Type' : 'application/json; charset=utf-8',
      'Accept'       : 'application/json',
      'Intelcia1'     : token1,
      'Intelcia2'     : token2
    });
    return headers;
  }

  public redirectBadRequest(err?: any) {
      /*if ([500].indexOf(err.status) > -1) {
        localStorage.clear();
        window.location.reload();
      }*/
      if ([0, 401, 400, 404, 500].indexOf(err.status) > -1) {
        this.router.navigateByUrl('/badrequest');
      }
      localStorage.setItem('errorHttp', JSON.stringify(err));
  }
}



// WEBPACK FOOTER //
// ./src/app/service/SessionService.ts